import type { IconProps } from '@src/components/icons/IconProps';

export function StarIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 2l2.09 6.26L20.5 9.27l-5 4.87L16.82 21 12 17.77 7.18 21 8.5 14.14l-5-4.87 6.41-1.01L12 2z" />
    </svg>
  );
}
